import { FC } from 'react';

import ArrowRight from '@/assets/icons/ArrowRight';
import { classNames } from '@/utils/classNames';

import { Reserve } from '../../types';
import { geefReserveTijd, geefReserveToelichting, isAchterstalligeReserve } from '../../utils/reserve';

import styles from './Reserve.module.css';

type ReserveToelichtingProps = {
  reserve: Reserve;
  className?: string;
};

/** Renders the "vanaf"/"verwacht gereed" toelichting row for a reserve, with an arrow icon and
 * (for ACHTERSTALLIG reserves) a strikethrough on the expected-ready time to signal it has
 * already passed. Renders nothing if there is no toelichting to show.
 *
 * @param props
 * @returns
 */
const ReserveToelichting: FC<ReserveToelichtingProps> = ({ reserve, className = undefined }) => {
  const reserveToelichting = geefReserveToelichting(reserve);
  if (!reserveToelichting) return null;

  return (
    <div className={classNames(styles.reserveToelichtingStyle, className)}>
      <ArrowRight className={styles.reserveToekomstIcoonStyle} aria-hidden='true' />
      {isAchterstalligeReserve(reserve) && reserve.buitenDienstTijd ? (
        <span>
          verwacht gereed:{' '}
          <span className={styles.achterstalligTijdStyle}>{geefReserveTijd(reserve.buitenDienstTijd)}</span>
        </span>
      ) : (
        <span>{reserveToelichting}</span>
      )}
    </div>
  );
};
export default ReserveToelichting;
